import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import type { Lookup, CustomFieldDef } from "@shared/types";

export function useLookups() {
  const { data } = useQuery({
    queryKey: ["lookups"],
    queryFn: () => api.get<{ lookups: Record<string, Lookup[]> }>("/lookups"),
    staleTime: 60_000,
  });
  const lookups = data?.lookups ?? {};
  return {
    lookups,
    byCategory: (cat: string): Lookup[] => (lookups[cat] ?? []).filter((l) => l.isActive),
    all: (cat: string): Lookup[] => lookups[cat] ?? [],
  };
}

export function useCustomFields(entity: "activity" | "project") {
  const { data } = useQuery({
    queryKey: ["custom-fields", entity],
    queryFn: () => api.get<{ fields: CustomFieldDef[] }>(`/custom-fields?entity=${entity}`),
    staleTime: 60_000,
  });
  return data?.fields ?? [];
}

export function useDirectory() {
  const { data } = useQuery({
    queryKey: ["directory"],
    queryFn: () => api.get<{ users: { id: string; fullName: string; username: string; jobTitle: string | null; avatarColor: string | null }[] }>("/users/directory"),
    staleTime: 60_000,
  });
  return data?.users ?? [];
}

export function useAppSettings() {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: () => api.get<{ settings: any }>("/settings"),
    staleTime: 120_000,
  });
  return data?.settings ?? null;
}
